import React, {Fragment} from 'react'
import {
  Button,
  Card,
  Title,
  Input,
  Charts,
  Select,
  RadioGroup,
  Icon,
  Head,
  ButtonAction,
  Table,
  FormGroup,
  ContentBlock,
  StatusDot,
  TreeSelect,
  DatePickerInputRange,
} from "xsolla-uikit";
import PAh2 from '../PAh2';

export function PAchartMain({children}) {
  return (

    <Fragment>

      <FormGroup>
        {children}
      </FormGroup>
  </Fragment>

  )
}





export function PAchartGists({options=[]}) {
  return (

    <Fragment>
      <div className="balance-chart__metrics"
        style={{justifyContent: 'space-between'}}
        >

      {options.map(({
        label='Total subsctibers',
        digit='13,923',
        percent='+13.93',
        subline='compared to the previous 30 days',
        invert
      }, ind)=> {return(
        <ChartsOneGist
        label={label}
        digit={digit}
        percent={percent}
        subline={subline}
        invert={invert}
      />
      )})}

        {/* <ChartsOneGist
          label='Total subsctibers'
          digit={'13,923'}
          percent={+13.93}
          subline={'compared to the previous 30 days'}
        />
        <ChartsOneGist
          label='Subsctiber Churn Rate'
          digit={'3%'}
          percent={1.93}
          invert={true}
          subline={'compared to the previous 30 days'}
        />
        <ChartsOneGist
          label='Subscriber LTV'
          digit={'1,018'}
          percent={+3}
          subline={'compared to the previous 30 days'}
        /> */}

      </div>
  </Fragment>

  )
}



export const ChartsOneGist = ({label, digit, percent, subline, invert}) => {
  return(
    // <FormGroup label={label}>

                <div className="balance-chart__metrics__metric">
                  <div className="statistic-card">
                    <div className="statistic-card__title">{label}</div>
                    <div
                      className="statistic-card__value statistic-card__value--non-zero"
                      data-id="balance-chart__metrics__metric__value_gross_revenue"
                    >
                      {digit}


                    </div>

                    {percent * (invert ? -1 : 1) < 0 && <div className="statistic-card__change">
                      <div className="statistic-card__arrow statistic-card__arrow--lose" />
                      <div className="statistic-card__percent statistic-card__percent--lose">
                        {percent}%
                      <div className="statistic-card__label">
                        {subline}
                      </div>
                      </div>
                    </div>}


                    {percent  * (invert ? -1 : 1) >= 0 && <Fragment><div className="statistic-card__change">
                      <div className="statistic-card__arrow statistic-card__percent--gross" />
                      <div className="statistic-card__percent statistic-card__percent--gross">
                        {percent}%
                      </div>
                      <div className="statistic-card__label">{subline}</div>
                    </div>
                      </Fragment>}


                  </div>
                </div>
  // </FormGroup>
  )
}